import {Dispatch} from 'redux';
import {DeviceClient, FileParameter} from '../../../api/api';
import {AsyncOperationBuilder} from '../../../utilities/api-helper';
import {setFromDate, setToDate} from '../../../utilities/helpers/date-helpers';
import {saveCSVFilefAs} from '../../../utilities/helpers/reducer-helpers';
import {deviceClient} from '../api-clients';
import {
  SetDeviceDatesAction,
  addUserDeviceAction,
  calibrateDeviceAction,
  deleteUserDeviceAction,
  getDevicesAction,
  getUserDeviceContentAction,
  selectAllAction,
  selectDeviceAction,
  updateCalibrationFactor,
  updateLabMeasurement,
  updateSpectral,
  updateSpectralMeasurementDateTime,
  updateStationId,
  uploadCsvAction,
} from './actions';

export async function getDevicesAdmin() {
  return AsyncOperationBuilder(
    getDevicesAction,
    (apiClient) => (apiClient as DeviceClient).getDevices(),
    undefined,
    deviceClient,
  );
}

export async function getDeviceContent(dateFrom: Date, dateTo: Date) {
  return AsyncOperationBuilder(
    getUserDeviceContentAction,
    (apiClient) => (apiClient as DeviceClient).getUserDevices(dateFrom, dateTo),
    undefined,
    deviceClient,
  );
}

export async function saveCalibrationFactor(calibrationFactor: number, deviceId: string) {
  return AsyncOperationBuilder(
    updateCalibrationFactor,
    (apiClient) => (apiClient as DeviceClient).updateCalibrationFactor(calibrationFactor, deviceId),
    {calibrationFactor, deviceId},
    deviceClient,
  );
}

export async function saveStationId(stationId: string, deviceId: string) {
  return AsyncOperationBuilder(
    updateStationId,
    (apiClient) => (apiClient as DeviceClient).updateStationId(stationId, deviceId),
    {stationId, deviceId},
    deviceClient,
  );
}

export async function saveSpectralMeasurement(spectralMeasurement: number, deviceId: string) {
  return AsyncOperationBuilder(
    updateSpectral,
    (apiClient) => (apiClient as DeviceClient).updateSpectralMeasurement(spectralMeasurement, deviceId),
    {spectralMeasurement, deviceId},
    deviceClient,
  );
}

export async function saveLabMeasurement(labMeasurement: number, deviceId: string) {
  return AsyncOperationBuilder(
    updateLabMeasurement,
    (apiClient) => (apiClient as DeviceClient).updateLabMeasurement(labMeasurement, deviceId),
    {labMeasurement, deviceId},
    deviceClient,
  );
}

export const selectDevice = (identifier: string) => {
  return (dispatch: Dispatch) => {
    dispatch(selectDeviceAction(identifier));
  };
};

export const setDevicesDates = (dateFrom: Date, dateTo: Date) => {
  setFromDate(dateFrom);
  setToDate(dateTo);
  return (dispatch: Dispatch) => {
    dispatch(SetDeviceDatesAction({dateFrom, dateTo}));
  };
};

export const selectAllDevices = () => {
  return (dispatch: Dispatch) => {
    dispatch(selectAllAction());
  };
};

export const getDevicesCSV = async (deviceIds: string[], dateFrom: Date, dateTo: Date) => {
  setFromDate(dateFrom);
  setToDate(dateTo);

  let fileResponse = await deviceClient.downloadCsv(deviceIds, dateFrom, dateTo);
  if (fileResponse) {
    saveCSVFilefAs(fileResponse, 'devices.csv');
  }
};

export async function calibrateDevice(deviceId: string, timeOfMeasurement: Date) {
  return AsyncOperationBuilder(
    calibrateDeviceAction,
    (apiClient) => (apiClient as DeviceClient).calibrateDevice(deviceId, timeOfMeasurement),
    {deviceId, timeOfMeasurement},
    deviceClient,
  );
}

export async function saveSpectralMeasurementDate(measurementDate: Date | undefined, deviceId: string) {
  return AsyncOperationBuilder(
    updateSpectralMeasurementDateTime,
    (apiClient) => (apiClient as DeviceClient).updateSpectralMeasurementDateTime(measurementDate, deviceId),
    {measurementDate, deviceId},
    deviceClient,
  );
}
export async function deleteUserDevice(deviceId: string, userId: string) {
  return AsyncOperationBuilder(
    deleteUserDeviceAction,
    (apiClient) => (apiClient as DeviceClient).deleteUserDevice(deviceId, userId),
    {deviceId, userId},
    deviceClient,
  );
}

export async function addUserDevice(deviceId: string, userId: string) {
  return AsyncOperationBuilder(
    addUserDeviceAction,
    (apiClient) => (apiClient as DeviceClient).addUserDevice(deviceId, userId),
    {deviceId, userId},
    deviceClient,
  );
}

export async function uploadDeviceCSV(deviceId: string, file: FileParameter) {
  return AsyncOperationBuilder(
    uploadCsvAction,
    (apiClient) => (apiClient as DeviceClient).uploadCsv(deviceId, file),
    {deviceId, file},
    deviceClient,
  );
}
